/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TargetCompany } from './TargetCompany';
import {
    TargetCompanyFromJSON,
    TargetCompanyFromJSONTyped,
    TargetCompanyToJSON,
    TargetCompanyToJSONTyped,
} from './TargetCompany';
import type { PatientInfo } from './PatientInfo';
import {
    PatientInfoFromJSON,
    PatientInfoFromJSONTyped,
    PatientInfoToJSON,
    PatientInfoToJSONTyped,
} from './PatientInfo';
import type { FacilityInfo } from './FacilityInfo';
import {
    FacilityInfoFromJSON,
    FacilityInfoFromJSONTyped,
    FacilityInfoToJSON,
    FacilityInfoToJSONTyped,
} from './FacilityInfo';

/**
 * 
 * @export
 * @interface CreateCallExecutionRequest
 */
export interface CreateCallExecutionRequest {
    /**
     * 
     */
    facility?: FacilityInfo;
    /**
     * 
     */
    target_company: TargetCompany;
    /**
     * The list of goals to achieve during the call
     */
    goal_list: Array<string>;
    /**
     * 
     */
    patient_info?: PatientInfo;
    /**
     * 
     */
    conference_phone_numbers?: Array<string>;
    /**
     * The phone number to call
     */
    target_phone_number?: string;
    /**
     * The ID of the user initiating the call
     */
    user_id?: string;
    /**
     * The name of the user initiating the call
     */
    user_name?: string;
    /**
     * The state where the member resides
     */
    member_state?: string;
}

/**
 * Check if a given object implements the CreateCallExecutionRequest interface.
 */
export function instanceOfCreateCallExecutionRequest(value: object): value is CreateCallExecutionRequest {
    if (!('target_company' in value) || value['target_company'] === undefined) return false;
    if (!('goal_list' in value) || value['goal_list'] === undefined) return false;
    return true;
}

export function CreateCallExecutionRequestFromJSON(json: any): CreateCallExecutionRequest {
    return CreateCallExecutionRequestFromJSONTyped(json, false);
}

export function CreateCallExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallExecutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility': json['facility'] == null ? undefined : FacilityInfoFromJSON(json['facility']),
        'target_company': TargetCompanyFromJSON(json['target_company']),
        'goal_list': json['goal_list'],
        'patient_info': json['patient_info'] == null ? undefined : PatientInfoFromJSON(json['patient_info']),
        'conference_phone_numbers': json['conference_phone_numbers'] == null ? undefined : json['conference_phone_numbers'],
        'target_phone_number': json['target_phone_number'] == null ? undefined : json['target_phone_number'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
        'member_state': json['member_state'] == null ? undefined : json['member_state'],
    };
}

export function CreateCallExecutionRequestToJSON(json: any): CreateCallExecutionRequest {
    return CreateCallExecutionRequestToJSONTyped(json, false);
}

export function CreateCallExecutionRequestToJSONTyped(value?: CreateCallExecutionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility': FacilityInfoToJSON(value['facility']),
        'target_company': TargetCompanyToJSON(value['target_company']),
        'goal_list': value['goal_list'],
        'patient_info': PatientInfoToJSON(value['patient_info']),
        'conference_phone_numbers': value['conference_phone_numbers'],
        'target_phone_number': value['target_phone_number'],
        'user_id': value['user_id'],
        'user_name': value['user_name'],
        'member_state': value['member_state'],
    };
}

